(function() {
  'use strict';

  angular.module('ringbaPortal').directive('jsPlumbAttach', jsPlumbAttach);

  function jsPlumbAttach(

  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      link: link
    };
    return directive;

    function link(scope, element) {
      window.jsPlumb.setContainer(element);

      $(window).resize(function() {
        window.jsPlumb.repaintEverything();
      });
    }
  }

})();
